export default __webpack_public_path__ + "static/media/PeopleSmallIcon.478e8eac.png";